var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"state8"},[_c('lib',{attrs:{"fixed-course-serialnumber":"0301","fixed-course-name":"专科微积分"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }